export default "__VITE_ASSET__BmJgCCSr__"